export function trackAddToCart() {
  if ((window as any).fbq) {
    ;(window as any).fbq('track', 'AddToCart', {
      content_name: 'Trading en Paz',
      content_type: 'product',
      value: 9.99,
      currency: 'USD',
    })
  }
}

export function trackInitiateCheckout() {
  if ((window as any).fbq) {
    ;(window as any).fbq('track', 'InitiateCheckout', {
      content_name: 'Trading en Paz',
      content_type: 'product',
      value: 9.99,
      currency: 'USD',
      num_items: 1,
    })
  }
}
